import { ITableElement } from "shared/components/interfaces";

export const columnsTableTransform = (columns: ITableElement<any>[], fieldToExclude: string[] = []): ITableElement<any>[] => {

    return columns.filter(column => !fieldToExclude.includes(column.field));
}